import { gsap } from "gsap";
import { Power2, Power3, ScrollTrigger } from "gsap/all";
import apiFetch from "@wordpress/api-fetch";
export default class Main {
  constructor() {
    let bd = document.getElementsByTagName("html")[0];
    let app = document.querySelector(".app");
    let ViewportWidth = window.innerWidth;
    this.ViewportWidth = ViewportWidth;
    let clicked = [];
    this.clicked = clicked;
    if (app) {
      let page = app.dataset.page;
      this.page = page;
    }
    this.bd = bd;
    // window.scrollTo({top: 0, behavior: 'smooth'});
  }
  render() {
    if (this.page === "percorsi-page" || this.page === "donne-in-olivetti-page") {
      var tag = document.createElement("script");

      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      this.initArchiveSection();
      setTimeout(() => {
        document.getElementById("year-1").click();
      }, 100);
      $(".js-single-year").on("click", this.slideToYear.bind(this));
      $(".js-open-panel").on("click", this.createPanel.bind(this));
      $(".js-scroll").on("click", this.scrollToSecondStep.bind(this));
      // $(".wrapper-panel").on("click", this.closePanel.bind(this));
      this.fetchDataCompasso();
    }


    if (this.page === "lettera-ventidue") {
      $(".loader").hide();
      var swiper = new Swiper(".mySwiper", {
        slidesPerView: 2,
        spaceBetween: 20,
        centeredSlides: true,
        loop: false,
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        navigation: {
          nextEl: ".swiper-next",
          prevEl: ".swiper-prev",
        },
        on: {
          slideResetTransitionEnd: (swiper) => {
            // alert('ínit')
            const active = document.querySelector('.swiper-slide-active')
            console.log(active)
          }
        }
      });

    }

    if (this.page === "donne-in-olivetti-page") {
      AOS.init();
    }
  }
  scrollToSecondStep() {
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".second-step").offset().top
    }, 200);
  }

  animateIntro() {
    // this.bd.classList.add('overflow');
    gsap.registerPlugin(ScrollTrigger);
    // let tl = gsap.timeline();
    // let tlText = gsap.timeline();
    // tl.to(".intro-title", {right:'20%', ease: Power2.easeInOut})
    // .to(".intro-title", {right:'2rem', ease: Power2.easeInOut})
    // .to(".intro-text", {right: "60%", ease: Power2.easeInOut})
    // .to(".intro-text", {right:'50%', ease: Power2.easeInOut})
    // ScrollTrigger.create({
    //   animation:tl,
    //   trigger:'.intro',
    //   start:'top top',
    //   scrub:true,
    //   pin:true
    // })
    // this.bd.classList.add('overflow');
    let tlTitle = gsap.timeline();
    let tlText = gsap.timeline();
    // animazione titolo intro
    tlTitle
      .to(
        ".intro-title",
        {
          scrollTrigger: {
            trigger: ".intro",
            toggleActions: "play none none none",
          },
          opacity: 1,
          duration: 0.5,
        },
        "+= 0.5",
      )
      .to(".intro-title", {
        duration: 10,
        right: "2rem",
        ease: "elastic.out(1.5, 1.6)",
      });

    // animazione testo intro
    tlText
      .to(
        ".intro-text",
        {
          scrollTrigger: {
            trigger: ".intro",
            toggleActions: "play none none none",
          },
          duration: 0.5,
          opacity: 1,
          ease: Power2.easeOut,
        },
        "+=.5",
      )
      .to(".intro-text", {
        duration: 5,
        right: "50%",
        ease: "elastic.out(.2, .6)",
        // ease: Power2.easeIn,
        onComplete: () => {
          this.bd.classList.remove("overflow");
        },
      })
      .to(".scroll-indicator", {
        duration: 0.5,
        opacity: 1,
        ease: Power2.easeIn,
      })
      ;

    if (this.page === "percorsi-page") {
      //  animazione second step adi
      gsap.to(".adi", {
        scrollTrigger: {
          trigger: ".second-step",
          start: "top center",
          // markers:true,
          toggleActions: "play none none none",
        },
        left: "17rem",
        right: "auto",
        duration: 3,
        onComplete: () => {
          gsap.to(".adi", {
            left: "20rem",
            duration: 1,
          });
        },
      });
      //  animazione second step index
      gsap.to(".index", {
        scrollTrigger: {
          trigger: ".second-step",
          start: "top center",
          toggleActions: "play none none none",
        },
        left: "15rem",
        duration: 3,
        onComplete: () => {
          gsap.to(".index", {
            left: "14rem",
            duration: 1,
            ease: Power2.easeInOut,
          });
        },
      });
      //  animazione second step design
      gsap.to(".design", {
        scrollTrigger: {
          trigger: ".second-step",
          start: "top center",
          toggleActions: "play none none none",
        },
        left: "10rem",
        duration: 3,
        onComplete: () => {
          gsap.to(".design", {
            left: "8rem",
            duration: 1,
          });
        },
      });
    }
  }
  initArchiveSection() {
    var swiper = new Swiper(".js-swiper-img", {
      autoHeight: true,
      slidesPerView: "auto",
      spaceBetween: 0,
      centeredSlides: true,
      direction: "vertical",
      allowTouchMove: false,
    });

    let direction = "horizontal";
    if (this.ViewportWidth > 768) {
      direction = "vertical";
    }
    var swiperText = new Swiper(".js-swiper-text", {
      centeredSlides: true,
      direction: direction,
      allowTouchMove: false,
    });
  }

  slideToYear(e) {
    let target = e.target;
    let index = e.target.dataset.index;

    target.classList.add("clicked");
    this.clicked.push(index);
    let last = this.clicked[this.clicked.length - 1];
    // console.log(typeof(+`${index}`));
    let heightOfEl = $(".js-single-year").height();
    let widthofEl = $(".js-single-year").width();
    if (this.ViewportWidth <= 768) {
      $(".line").css({
        width: (+`${index}` * `${widthofEl}`) + (+`${index}` * 20)
      })
    } else {
      $(".line").css({
        height: +`${index}` * `${heightOfEl}`
      })
    }

    // console.log(heightOfEl);
    $(".js-single-year").removeClass("active");
    target.classList.add("active");
    document
      .querySelector(".js-swiper-text")
      .swiper.slideTo(index - 1, 300, false);
    document
      .querySelector(".js-swiper-img")
      .swiper.slideTo(index - 1, 300, false);
  }
  fetchDataCompasso(e) {
    var url = document.querySelector('.app').dataset.fetch;
    if (window.location.href.includes("/en/")) {
      url = "/en/" + url;
    }
    fetch(`${url}`)
      .then((rs) => rs.json())
      .then((data) => {
        $(".loader").hide();
        if (this.ViewportWidth > 660) {
          this.animateIntro();
        }
        this.data = data;
        //console.log(data);
      });
  }
  createPanel(e) {
    let id = e.target.dataset.id;
    // console.log(this.data);
    // console.log(id);
    let data = this.data.filter((item) => item.id == id);
    console.log(data);
    // console.log(data);
    for (let x = 0; x < data.length; x++) {
      let archivi = data[x].acf.archivio;
      // console.log(archivi);
      for (let y = 0; y < archivi.length; y++) {
        let singleArchivio = $("#template-archivio").clone();
        singleArchivio.attr("id", `archivio-${y}`);
        $(".js-title-label", singleArchivio).html(archivi[y].label_title);
        $(".js-title", singleArchivio).html(archivi[y].titolo);
        //inizializzo la gallery
        let sliders = archivi[y].gallery;
        for (let j = 0; j < sliders.length; j++) {
          // console.log(sliders[j]);
          let slide = $("#template-slide").clone();

          slide.attr("id", "slide-" + j);
          $(".js-image", slide).attr("src", sliders[j].immagine);
          if (this.isNullOrEmpty(sliders[j].id_video)) {
            $(".js-play", slide).hide();
            $(".js-image", slide).attr("href", sliders[j].immagine);
          }
          $(".js-play", slide).on(
            "click",
            this.openModalVideo.bind(this, sliders[j].id_video),
          );

          //slider descr
          var slideDescr = $("#template-slide-description").clone();
          slideDescr.attr("id", `descr-${j}`);
          $(".js-text", slideDescr).html(sliders[j].descrizione);

          if (this.isNullOrEmpty(sliders[j].cta)) {
            $(".js-panel-cta", slideDescr).hide();
          } else {
            $(".js-panel-cta", slideDescr).attr("href", sliders[j].cta.url);
            $(".js-panel-cta", slideDescr).html(sliders[j].cta.title);
          }
          // if (this.isNullOrEmpty(sliders[j].cta.title)) {
          //   $(".js-panel-cta", singleArchivio).html("Scopri di più");
          // }
          //append degli elementi
          $(".js-descr-wrapper", singleArchivio).append(slideDescr);
          $(".js-wrapper-slide-img", singleArchivio).append(slide);
        }

        $(".js-wrapper-content-panel").append(singleArchivio);
        $(".js-descr-slide-arch", singleArchivio).addClass(
          `js-descr-slide-arch-${y}`,
        );
        $(".js-archive-slider", singleArchivio).addClass(
          `js-archive-slide-${y}`,
        );
        // init dei due slider con callback
        var descrSlider = new Swiper(`.js-descr-slide-arch-${y}`, {
          slidesPerView: 1,
          centeredSlides: true,
          zoom: false,
          on: {
            activeIndexChange: (e) => {
              document
                .querySelector(`.js-archive-slide-${y}`)
                .swiper.slideTo(e.activeIndex, 300, false);
            },
          },
        });
        var arcSwiper = new Swiper(`.js-archive-slide-${y}`, {
          slidesPerView: 1.5,
          spaceBetween: 30,
          // centeredSlides: true,
          zoom: false,
          navigation: {
            nextEl: ".arrow-next",
            prevEl: ".arrow-prev",
          },
          on: {
            activeIndexChange: (e) => {
              console.log(e.activeIndex);
              document
                .querySelector(`.js-descr-slide-arch-${y}`)
                .swiper.slideTo(e.activeIndex, 300, false);
            },
          },
        });
      }
      $(".wrapper-panel").addClass("open");
      $("html").addClass("overflow");
      $(".i-premi").addClass("panel-open");

      $(".js-close").on("click", this.closePanel.bind(this));
    }
  }

  openModalVideo(videoID) {
    let modal = document.querySelector(".js-modal-video");
    modal.classList.add("open");

    $(".player-video").show();
    // let videoID = e.target.dataset.video;
    console.log(videoID);
    var player;
    player = new YT.Player("player", {
      videoId: `${videoID}`,
      playlist: `${videoID}`,
      fov: 100,
      rel: 0,
      loop: 1,
      showinfo: 0,
      events: {
        onReady: (e) => {
          e.target.playVideo();
        },
      },
    });
    modal.querySelector(".close").addEventListener("click", (e) => {
      modal.classList.remove("open");
      $("#player").remove();
      player.stopVideo();
      let newPlayer = document.createElement("div");
      newPlayer.setAttribute("id", "player");
      $(".player-video").append(newPlayer);
    });
  }

  closePanel() {
    $(".wrapper-panel").removeClass("open");
    $("html").removeClass("overflow");
    $(".i-premi").removeClass("panel-open");
    setTimeout(() => {
      $(".js-wrapper-content-panel").empty();
    }, 400);
  }
  isNullOrEmpty(xValue) {
    if (typeof xValue == "boolean") {
      return false;
    } else {
      if (xValue == null || xValue == undefined || xValue == "") {
        return true;
      }
    }
    return false;
  }
}
